import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss', './intro.component.media.scss']
})
export class IntroComponent implements OnInit {
  companyArr = [
    './assets/DSC_1333.jpg',
    './assets/DSC_1334.jpg',
    './assets/DSC_1335.jpg'
  ];
  creditArr = [
    './assets/quality-1.jpg',
    './assets/quality-2.jpg'
  ];
  bottomArr = [
    {
      title: '19年模具之路',
      content: '19年'
    },
    {
      title: '专业研发团队',
      content: '100+'
    },
    {
      title: '国际质量标准',
      content: 'ISO9001'
    }
  ];
  developmentArr = [
    {
      year: 2002,
      content: 'Ningbo Beilun Huari Metla Products Co., LTD was established'
    },
    {
      year: 2009,
      content: 'Fully implemented the ISO9001:2000 quality management system'
    },
    {
      year: 2010,
      content: 'Start the business for the export'
    },
    {
      year: 2013,
      content: 'Establish a subsidiary "Ningbo Artisan Machinery"'
    },
    {
      year: 2014,
      content: 'Implement the TS16949:2000 quality management system'
    },
    {
      year: 2016,
      content: 'Purchase new die casting machine(1000T) and CNC machine ,increasing the production capacity'
    },
    {
      year: 2018,
      content: 'To complete the IATF16949 update '
    },
    {
      year: 2019,
      content: 'Purchase new die casting machine(1600T) '
    }
  ];
  constructor() { }

  ngOnInit() {
  }

}
